import SliderDefault from '../SliderDefault'
import { CONTROL_POSITION } from '../../../constants/slider'

const SliderV2 = (props) => {
  return (
    <SliderDefault
      {...props}
      controlPosition={CONTROL_POSITION.BOTTOM}
      showHeader={false}
    />
  )
}

export default SliderV2
